// config/API.js
// const API_URL = "https://bamizban.com"; // یا آدرس واقعی بک‌اندت
const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
export default API_URL;
